import moment from 'moment';

export const filesConfig = {
  api: () => '/files',
  title: 'Files',
  isActionTab: true,
  moreActions: [
    {
      name: 'View PDF',
      action: 'pdf',
      getKey: (value) => value.file,
      buttonText: null,
      isButtonHide: true
    },
  ],
  maskClosable: false,
  modalTitle: (action) => action + ' Files',
  getColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'File Type',
        dataIndex: 'fileType',
        key: 'fileType',
      },
      {
        title: 'Valid Till',
        dataIndex: 'validTill',
        key: 'validTill',
        render: (text) => {
          return moment(text).format('lll');
        }
      },

    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'File',
        dataIndex: 'file',
        key: 'file',
        type: 'file',
        multiple: false,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        type: 'text',
        isRequired: true,
        formClassName: 'col-4 pb-2',
      },

      {
        title: 'File Type',
        dataIndex: 'fileType',
        key: 'fileType',
        type: 'select',
        children: ['PDF', 'Image', 'Doc'].map(ele => ({ name: ele, value: ele })),
        required: false,
        formClassName: 'col-4 pb-2',
      },
      {
        title: 'Valid Till',
        dataIndex: 'validTill',
        key: 'validTill',
        type: 'date',
        isRequired: false,
        formClassName: 'col-4 pb-2',
      },

    ];
  },
  combo: [],
  getData: () => ({}),
  actions: [
    { name: 'Add file', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
